import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import checkLogin from "../plugins/checkLogin";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "index",
        component: () => import("../views/index/index.vue"),
        meta: {
            metaInfo: {
                title: " 快哦-2020新广告法违禁词_淘宝违规词_抖音禁用词_图片敏感词极限词在线检测查询工具",
                keywords:
                    "快哦，新广告法，阿里巴巴产品违禁词，阿里巴巴违禁词，图片违禁词，文字违禁词，文章违禁词，极限词，敏感词，违规词，禁用词，限制词，淘宝违禁词，天猫极限词",
                description:
                    "快哦为您提供2020年最新广告法违禁词查询工具，适合电商平台在线检测图片违禁词，文字敏感词。快哦 kuaio.cn",
            },
            title: "首页",
            isNavList: true,
        },
    },
    {
        path: "/illegalWord",
        redirect: "/illegalWord/aliProduct",
        component: () => import("../views/illegalWord/illegalWord.vue"),
        meta: {
            title: "违禁词检测",
            isNavList: true,
        },
        children: [
            {
                path: "/aliProduct",
                component: () =>
                    import("../views/illegalWord/aliProduct/layout"),
                children: [
                    {
                        path: "/illegalWord/aliProduct",
                        name: "aliProduct",
                        meta: {
                            metaInfo: {
                                title: "阿里巴巴产品违规词_1688商品违禁词_禁用词极限词在线检测查询工具-快哦",
                                keywords:
                                    "快哦，阿里巴巴产品违禁词，阿里巴巴违禁词，1688违禁词，1688产品检测，店铺商品违禁词",
                                description:
                                    "快哦为您提供阿里巴巴产品违禁词敏感词在线检测，适合电商平台在线检测图片违禁词，产品标题和详情页的违禁词。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import(
                                "../views/illegalWord/aliProduct/aliProduct"
                            ),
                    },
                    {
                        path: "/illegalWord/aliCheckRecord",
                        name: "aliCheckRecord",
                        meta: {
                            metaInfo: {
                                title: "阿里巴巴产品违规词_1688商品违禁词_禁用词极限词在线检测查询工具-快哦",
                                keywords:
                                    "快哦，阿里巴巴产品违禁词，阿里巴巴违禁词，1688违禁词，1688产品检测，店铺商品违禁词",
                                description:
                                    "快哦为您提供阿里巴巴产品违禁词敏感词在线检测，适合电商平台在线检测图片违禁词，产品标题和详情页的违禁词。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import(
                                "../views/illegalWord/aliProduct/aliCheckRecord"
                            ),
                    },
                ],
            },
            {
                path: "/imgCheck",
                component: () => import("../views/illegalWord/imgCheck/layout"),
                children: [
                    {
                        path: "/illegalWord/imgCheck",
                        name: "imgCheck",
                        meta: {
                            metaInfo: {
                                title: "2020新广告法图片违禁词_淘宝违规词_抖音禁用词_在线图片禁用词极限词检测查询工具-快哦",
                                keywords:
                                    "快哦，图片违禁词，图片禁用词，图片限制词，图片极限词，图片违规词",
                                description:
                                    "快哦为您提供图片违禁词敏感词在线检测，适合电商平台在线检测图片违禁词禁用词极限词敏感词。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import("../views/illegalWord/imgCheck/imgCheck"),
                    },
                    {
                        path: "/illegalWord/imgCheckRecord",
                        name: "imgCheckRecord",
                        meta: {
                            metaInfo: {
                                title: "2020新广告法图片违禁词_淘宝违规词_抖音禁用词_在线图片禁用词极限词检测查询工具-快哦",
                                keywords:
                                    "快哦，图片违禁词，图片禁用词，图片限制词，图片极限词，图片违规词",
                                description:
                                    "快哦为您提供图片违禁词敏感词在线检测，适合电商平台在线检测图片违禁词禁用词极限词敏感词。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import(
                                "../views/illegalWord/imgCheck/imgCheckRecord"
                            ),
                    },
                    {
                        path: "/illegalWord/imgCheckRecordold",
                        name: "imgCheckRecordold",
                        meta: {
                            metaInfo: {
                                title: "2020新广告法图片违禁词_淘宝违规词_抖音禁用词_在线图片禁用词极限词检测查询工具-快哦",
                                keywords:
                                    "快哦，图片违禁词，图片禁用词，图片限制词，图片极限词，图片违规词",
                                description:
                                    "快哦为您提供图片违禁词敏感词在线检测，适合电商平台在线检测图片违禁词禁用词极限词敏感词。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import(
                                "../views/illegalWord/imgCheck/imgCheckRecordold"
                            ),
                    },
                ],
            },
            {
                path: "/illegalWord/textCheck",
                name: "textCheck",
                meta: {
                    metaInfo: {
                        title: "2020新广告法违禁词_淘宝违规词_抖音禁用词_文字敏感词极限词词库免费在线检测查询工具-快哦",
                        keywords:
                            "快哦，文字违禁词，文字禁用词，文章违禁词，文字限制词，文字极限词，文字违规词",
                        description:
                            "快哦为您提供文字违禁词敏感词在线检测，适合电商平台在线检测文字违禁词禁用词极限词敏感词。快哦 kuaio.cn",
                    },
                },
                component: () =>
                    import("../views/illegalWord/textCheck/textCheck"),
            },
            {
                path: "/illegalWord/manageIllgalWord",
                name: "manageIllgalWord",
                meta: {
                    metaInfo: {
                        title: "2020新广告法违禁词_淘宝违规词_抖音禁用词_敏感词极限词在线词库-快哦",
                        keywords:
                            "快哦，批量添加违禁词，批量清除违禁词，删除替换违禁词",
                        description:
                            "快哦为您免费提供行业违禁词,敏感词，极限词,词库库管理，支持自定义批量增加和清除违禁词。快哦 kuaio.cn",
                    },
                },
                component: () =>
                    import(
                        "../views/illegalWord/manageIllgalWord/manageIllgalWord"
                    ),
            },
        ],
    },
    {
        path: "/illegalFont",
        meta: {
            title: "方正字体检测",
            isNavList: true,
        },
        redirect: "/illegalFont/fontCheck",
        component: () => import("../views/illegalFont/index.vue"),
        children: [
            {
                path: "/illegalFont",
                redirect: "/illegalFont/fontCheck",
                component: () =>
                    import("../views/illegalFont/fontCheck/layout"),
                children: [
                    {
                        path: "/illegalFont/fontCheck",
                        name: "fontCheck",
                        meta: {
                            metaInfo: {
                                title: "方正字体检测_淘宝抖音拼多多平台在线图片方正字体检测查询工具-快哦",
                                keywords:
                                    "快哦，图片方正字体检测，字体侵权，淘宝抖音拼多多平台，批量检测方正字体",
                                description:
                                    "快哦为您提供图片方正字体侵权检测，适合电商平台在线检测图片方正字体侵权。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import("../views/illegalFont/fontCheck/fontCheck"),
                    },
                    {
                        path: "/illegalFont/fontCheckRecord",
                        name: "fontCheckRecord",
                        meta: {
                            metaInfo: {
                                title: "方正字体检测_淘宝抖音拼多多平台在线图片方正字体检测查询工具-快哦",
                                keywords:
                                    "快哦，图片方正字体检测，字体侵权，淘宝抖音拼多多平台，批量检测方正字体 ",
                                description:
                                    " 快哦为您提供图片方正字体侵权检测，适合电商平台在线检测图片方正字体侵权。快哦 kuaio.cn",
                            },
                        },
                        component: () =>
                            import(
                                "../views/illegalFont/fontCheck/fontCheckRecord.vue"
                            ),
                    },
                ],
            },
        ],
    },

    {
        path: "/buy",
        name: "buy",
        meta: {
            metaInfo: {
                title: "购买套餐_淘宝违规词_抖音禁用词_敏感词极限词-快哦",
                keywords: "快哦，违禁词图片订购违禁词，禁用词，敏感词",
                description:
                    "快哦为您提供价廉物美的图片违禁词,敏感词，极限词套餐，买图片检测套餐更划算。快哦 kuaio.cn",
            },
            title: "购买",
            isNavList: true,
        },
        component: () => import("../views/buy/buy.vue"),
    },
    {
        path: "/shopsManagement",
        name: "shopsManagement",
        meta: {
            metaInfo: {
                title: "店铺管理-快哦违禁词",
                keywords:
                    "快哦，1688店群管理，多店铺管理，违禁词，禁用词，敏感词",
                description: "快哦为您提供阿里1688店群管理。快哦 kuaio.cn",
            },
        },
        component: () => import("../views/shopsManagement/shopsManagement.vue"),
    },
    {
        path: "/contactUs",
        name: "contactUs",
        meta: {
            metaInfo: {
                title: "联系我们-快哦违禁词",
                keywords: "快哦，联系客服17759126083，违禁词，禁用词，敏感词",
                description:
                    "快哦为您提供良好的产品体验，售后问题联系客服17759126083。快哦 kuaio.cn",
            },
            title: "联系我们",
            isNavList: true,
        },
        component: () => import("../views/contactUs/contactUs.vue"),
    },
    {
        path: "/userPact",
        name: "userPact",
        component: () => import("../views/contactUs/userPact.vue"),
    },
    {
        path: "/Home",
        name: "Home",
        component: () => import("../views/Home.vue"),
    },
    {
        path: "*",
        name: "404",
        component: () => import("../views/404.vue"),
    },
    {
        path: "/error500",
        name: "error500",
        component: () => import("../views/500.vue"),
    },
    {
        path: "/networkError",
        name: "networkError",
        component: require("@/views/networkError.vue").default,
    },
    {
        path: "/about",
        name: "About",
        component: () => import("../views/About.vue"),
        meta: {
            title: "阿里巴巴1688产品违禁词敏感词禁用词极限词在线检测工具-快哦电商企业智能工具平台",
            keywords:
                "快哦，阿里巴巴产品违禁词，阿里巴巴违禁词，1688违禁词，1688产品检测，方正字体侵权，店铺商品违禁词",
            description:
                "快哦为您提供2020年最新广告法违禁词查询工具，适合电商平台在线检测图片违禁词，图片方正字体侵权，文字敏感词，电商企业智能工具选快哦 kuaio.cn",
        },
    },
    {
        path: "/flow",
        component: () => import("../views/flow/components/TheLayout.vue"),
        children: [
            {
                path: "/",
                name: "flow",
                component: () => import("../views/flow/index.vue"),
                meta: {
                    needLogin: true,
                },
            },
            {
                path: "charge",
                name: "flowCharge",
                component: () => import("../views/flow/charge.vue"),
                meta: {
                    needLogin: true,
                },
            },
        ],
    },
];

const router = new VueRouter({
    // mode: "history",
    path: "/",
    routes,
});

// TODO 路由权限
router.beforeEach(async (to, from, next) => {
    if (to.path.indexOf("illegalWord") != -1) {
        store.state.isActivityBanner = false;
    } else {
        store.state.isActivityBanner = true;
    }
    if (to.meta.metaInfo) store.commit("CAHNGE_META_INFO", to.meta.metaInfo);

    if (to.meta.needLogin && !checkLogin()) {
        next("/");
    } else if (to.query.st) {
        store.commit("checkeShopToolToken", to.query.st);
        delete to.query["st"];
        next(to);
    } else {
        next();
    }
});

export default router;
